module.exports = __webpack_public_path__ + "img/pic-3.e395eb5e.png";